import { render } from "./BookmarkToggle.vue?vue&type=template&id=53350fba"
import script from "./BookmarkToggle.vue?vue&type=script&lang=js"
export * from "./BookmarkToggle.vue?vue&type=script&lang=js"
script.render = render

export default script